import CompanySelectDropdown from "containers/company/CompanySelectDropdown";
import { Form, Formik, type FormikHelpers } from "formik";
import {
  type CompanyAssetAction,
  type ConfigAssetAction,
  type FirmwareUpgradeAssetAction,
  type RelayAssetAction,
  actionTypesEnum,
} from "kubb";
import type React from "react";
import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import type { Asset } from "utils/object";
import * as Yup from "yup";
import { Button } from "../../../components/Theme/button";
import AssetActionConfirmModal from "../assetActions/AssetActionConfirmModal";

interface FormValues {
  company_id: string;
}

interface Props {
  asset: Asset;
}

const AssetCompanyAssignForm = (props: Props): React.ReactElement => {
  const [open, setOpen] = useState(false);
  const [action, setAction] = useState<
    | CompanyAssetAction
    | ConfigAssetAction
    | FirmwareUpgradeAssetAction
    | RelayAssetAction
    | undefined
  >(undefined);
  const [complete, setComplete] = useState(false);

  const location = useLocation();
  const navigate = useNavigate();

  const openModal = (): void => {
    setOpen(true);
  };

  const closeModal = (): void => {
    setOpen(false);
  };

  const submit = (
    values: FormValues,
    { setSubmitting }: FormikHelpers<FormValues>,
  ): void => {
    setSubmitting(true);
    setAction({
      action_type: actionTypesEnum.ASSIGN_TO_COMPANY,
      company_id: values.company_id,
    } as CompanyAssetAction);
    openModal();
  };

  const onComplete = (): void => {
    navigate({ pathname: "/admin/asset", hash: location.hash });
  };

  const initialValues = {
    company_id: "",
  };
  return (
    <>
      <Formik
        onSubmit={submit}
        initialValues={initialValues}
        validateOnMount={true}
        validationSchema={Yup.object().shape({
          company_id: Yup.string()
            .required("Required")
            .notOneOf(["undefined", ""]),
        })}
        render={({
          isValid,
          isSubmitting,
          resetForm,
          setSubmitting,
        }): React.ReactElement => (
          <Form data-cy={"assign-asset-form"}>
            <CompanySelectDropdown fieldName={"company_id"} allowNone={true} />
            <Button
              type={"submit"}
              color={"brandLight"}
              disabled={isSubmitting || !isValid}
            >
              Assign
            </Button>
            {action && (
              <AssetActionConfirmModal
                show={open}
                asset={props.asset}
                action={action}
                close={closeModal}
                description={"Assign Asset"}
                onComplete={(): void => {
                  resetForm();
                  setSubmitting(false);
                  setComplete(true);
                }}
                onClose={(): void => {
                  setSubmitting(false);
                  if (complete) {
                    onComplete();
                  }
                }}
              />
            )}
          </Form>
        )}
      />
    </>
  );
};

export default AssetCompanyAssignForm;
